import { BaseAmountTable } from '../../libs/amount_table'

declare const $: any

class LocationAmountTable extends BaseAmountTable {
  constructor() {
    super('.campaign_item_amount', true)
  }
}

export default function initCampaignsLocation() {
  const { $ } = window as any
  $(document).on('ready', () => {
    // Initialize amount table
    new LocationAmountTable()
  })
}
